export default __webpack_public_path__ + "static/media/AbliminalSustainabilityReport.5e83f110.pdf";